export class Wait {
    waiting = false;
    result: boolean | null = null;

    sleep(ms: number) {
        return new Promise((resolve) => window.setTimeout(resolve, ms));
    }

    proceed() {
        this.result = true;
        this.waiting = false;
    }

    cancel() {
        this.result = false;
        this.waiting = false;
    }

    start() {
        this.result = null;
        this.waiting = true;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise<boolean | null>(async (resolve) => {
            while (this.waiting) {
                await this.sleep(100);
            }
            resolve(this.result);
        });
    }
}
